import React, { useEffect } from "react";
import { useAllBannerQuery } from "../../redux/API/BannerApi";
import { bannerImgUrl, ImgUrl } from "../../admin/Constant";
import AOS from "aos";
import "aos/dist/aos.css";

const Banner = () => {
  const { data, isLoading} = useAllBannerQuery();
  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);


   const banner = data?.data.filter((banner) => banner.status === "active");
  

  return (
    <div className="hero_banner">
      
       
            <div
              id="banner-carousel"
              className="carousel slide h-100"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner h-100">
                {!isLoading && banner && banner.length > 0 ? (
                  banner?.map((banner, index) => (
                    <div
                      key={banner._id}
                      className={`carousel-item h-100 ${index === 0 ? "active" : ""}`}
                    >
                      <img
                        className="w-100 h-100 object-fit-cover"
                        src={`${ImgUrl}${bannerImgUrl}${banner.image}`}
                        alt={`Banner ${index + 1}`}
                      />
                      <div className="carousel-caption d-flex flex-column align-items-center justify-content-center mb-lg-5 pb-lg-5">
                        <h1  data-aos="fade-up ">
                          {banner.title}
                        </h1>
                      </div>
                    </div>
                  ))
                ) : (
''
                )}
              </div>
            </div>
            
    </div>
  );
};

export default Banner;
